const focus = {
	inserted: function (el) {
		if(['textarea', 'input'].includes(el.tagName.toLocaleLowerCase())){
			el.focus();
		} else {
			if(el.getElementsByTagName('input').length > 0){
				el.getElementsByTagName('input')[0].focus()
			}
			if(el.getElementsByTagName('textarea') > 0){
				el.getElementsByTagName('textarea')[0].focus()
			}
		}
	},
}
export default focus;